
import { supabase } from "@/integrations/supabase/client";

export const uploadPhoto = async (
  croppedFile: File,
  userId: string,
  existingImageUrl: string | null
) => {
  const fileExt = 'jpg';  // Force jpg extension for consistency
  const filePath = `${userId}/${crypto.randomUUID()}.${fileExt}`;

  console.log('Starting photo upload process:', { filePath, fileSize: croppedFile.size });

  // Delete existing profile photo if any
  if (existingImageUrl) {
    try {
      console.log('Attempting to delete old photo:', existingImageUrl);
      // Extract the user ID and filename from the URL path
      const pathParts = existingImageUrl.split('/');
      const oldUserId = pathParts[pathParts.length - 2];
      const oldFileName = pathParts[pathParts.length - 1];
      
      if (oldUserId && oldFileName) {
        const oldPath = `${oldUserId}/${oldFileName}`;
        console.log('Calculated old path for deletion:', oldPath);
        
        const { error: deleteError } = await supabase.storage
          .from('profile-photos')
          .remove([oldPath]);
        
        if (deleteError) {
          console.error('Error removing old photo:', deleteError);
          // Continue with upload even if delete fails
        } else {
          console.log('Successfully deleted old photo');
        }
      }
    } catch (error) {
      console.error('Error during old photo deletion:', error);
      // Continue with upload even if delete fails
    }
  }

  // Upload new photo
  console.log('Uploading new photo...');
  const { error: uploadError, data: uploadData } = await supabase.storage
    .from('profile-photos')
    .upload(filePath, croppedFile, { 
      upsert: true,
      contentType: 'image/jpeg'
    });

  if (uploadError) {
    console.error('Upload error:', uploadError);
    throw uploadError;
  }

  if (!uploadData) {
    console.error('No upload data returned from Supabase');
    throw new Error('No upload data returned');
  }

  console.log('Photo uploaded successfully, getting public URL');
  const { data: { publicUrl } } = supabase.storage
    .from('profile-photos')
    .getPublicUrl(filePath);

  console.log('Got public URL:', publicUrl);

  // Update profile with new image URL
  console.log('Updating profile with new image URL');
  const { error: updateError } = await supabase
    .from('profiles')
    .update({ image_url: publicUrl })
    .eq('id', userId);

  if (updateError) {
    console.error('Profile update error:', updateError);
    throw updateError;
  }

  console.log('Profile updated successfully');
  return publicUrl;
};
